import React, { Component, lazy } from 'react';
import { connect } from 'react-redux';
import { Collapse } from 'react-collapse';
import _ from 'lodash';
import produce from 'immer';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';

import { Button, Popup } from '../common';
import { YearRange, TextInput } from '../form';
import PropertiesSelect from '../form/PropertiesSelect';
import SelectGroup from '../form/SelectGroup';

// Helper
import {
  _findArrayOption,
  _findArrayNestedOption,
  _filterCountry,
  _filterCountryYearsWithProcess,
} from './../../utils/helper';
import { FiltersLabel, FiltersTooltip } from './../../utils/constant';

import { searchParamsChanged, submitSearchParams, clearAllFilters } from '../../redux/actions';

const InitialWrapper = (props) => {
  if (props.layout === 'home') {
    return <div className="form-block hlp-mb-50">{props.children}</div>;
  }
  return <div>{props.children}</div>;
};

const AdvanceWrapper = (props) => {
  if (props.layout === 'home') {
    return (
      <div className="home-advanced-search hlp-mb-50">
        <div className="hlp-pt-15">
          <div className="text-center">
            <div
              className={`toggle ${props.advanceToggle}`}
              onClick={props.onAdvancedSearchToggle}>
              <div className="flex-grow-me hlp-flex flex-aic flex-jcfe">
                <Popup
                  className="helptip-text"
                  trigger={() => <span className="helptip"></span>}
                  position="top center"
                  on={['hover']}
                  closeOnDocumentClick>
                  <span>
                    Filter search according to key contextual factors and
                    properties of the constitution building process
                  </span>
                </Popup>
                <span>&nbsp;&nbsp;General Filters</span>
              </div>
            </div>
            <div
              className={`toggle ${props.topicToggle}`}
              onClick={props.onTopicSearchToggle}>
              <div className="flex-grow-me hlp-flex flex-aic flex-jcfe">
                <Popup
                  className="helptip-text"
                  trigger={() => <span className="helptip"></span>}
                  position="top center"
                  on={['hover']}
                  closeOnDocumentClick>
                  <span>
                    Search for particular properties within the eight
                    constitution building stages
                  </span>
                </Popup>
                <span>&nbsp;&nbsp;Specific Search Topics</span>
              </div>
            </div>
          </div>
        </div>

        <div className={`form-block active`}>{props.children}</div>
      </div>
    );
  }
  return <div>{props.children}</div>;
};

class SearchForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sideBarKeywords: '',
      stageTopics: [],
      advancedSearchActive: false,
      topicSearchActive: false,
      sidebarFiltersActive: true,
      sidebarTopicsActive: false,
    };
  }

  filterRef = [];

  componentDidUpdate(prevProps) {
    const stages = this.props.data.stages;
    if (prevProps.data.stages !== stages) {
      let previousSearchTopics = stages.map((jsonStage) => {
        return jsonStage.topics.filter(
          (topic) =>
            this.props.search_params.stages.topics &&
            this.props.search_params.stages.topics.indexOf(topic.value) >= 0,
        );
      });

      // Second .map pass to get value only
      previousSearchTopics = previousSearchTopics.map((stage) => {
        return stage.map((topic) => {
          return topic.value;
        });
      });

      previousSearchTopics.unshift([]);

      let advancedSearchActive = this.state.advancedSearchActive;
      let topicSearchActive = this.state.topicSearchActive;

      let sidebarFiltersActive = this.state.sidebarFiltersActive;
      let sidebarTopicsActive = this.state.sidebarTopicsActive;

      if (!this.state.topicSearchActive) {
        advancedSearchActive = false;
        sidebarFiltersActive = true;
        topicSearchActive = false;
        sidebarTopicsActive = false;

        Object.keys(this.props.search_params.advancedSearch).forEach((key) => {
          if (this.props.search_params.advancedSearch[key].length > 0) {
            advancedSearchActive = true;
            return;
          }
        });

        if (
          this.props.search_params.stages.topics &&
          this.props.search_params.stages.topics.length > 0
        ) {
          topicSearchActive = true;
          sidebarTopicsActive = true;
          sidebarFiltersActive = false;
        }
      }

      this.setState({
        sideBarKeywords: '',
        stageTopics: previousSearchTopics,
        advancedSearchActive,
        topicSearchActive,
        sidebarFiltersActive,
        sidebarTopicsActive,
      });
    }
  }

  onSearchParamsChanged(value, field, subfield) {
    console.log('boo', value);
    console.log('boo', field);
    console.log('boo', subfield);
    this.props.searchParamsChanged(value, field, subfield);

    //trigger form submit if not on home page
    if (field === 'keyword') {
      return;
    }

    if (this.props.layout !== 'home') {
      setTimeout(
        () => this.props.submitSearchParams(this.props.search_params),
        100,
      );
    }

    if (this.props.layout !== 'home' && this.props.layout !== 'searchResult-search') {
      setTimeout(
        () => this.props.history.push('/search'),
        100,
      );
    }

  }

  onAdvancedSearchToggle() {
    if (!this.state.advancedSearchActive) {
      this.setState({ topicSearchActive: false });
    }
    this.setState({
      advancedSearchActive: !this.state.advancedSearchActive,
    });
  }

  onTopicSearchToggle() {
    if (!this.state.topicSearchActive) {
      this.setState({ advancedSearchActive: false });
    }
    this.setState({
      topicSearchActive: !this.state.topicSearchActive,
    });
  }

  onSidebarFiltersToggle(tab) {
    if (tab === 1 && this.state.sidebarFiltersActive) {
      return;
    }
    if (tab === 2 && this.state.sidebarTopicsActive) {
      return;
    }

    const sidebarFiltersActive = !this.state.sidebarFiltersActive;
    const sidebarTopicsActive = !this.state.sidebarTopicsActive;

    this.setState({
      sidebarFiltersActive,
      sidebarTopicsActive,
    });
  }

  sideBarKeywordsChanged(event) {
    this.setState({ sideBarKeywords: event.target.value });
  }

  onSubmitSideBarKeywords() {
    const keywords = this.state.sideBarKeywords;

    this.onSearchParamsChanged(keywords, 'keyword', '');

    // this.props.submitSearchParams(this.props.search_params);

    this.props.submitSearchParams({
      initialSearch: this.props.search_params.initialSearch,
      advancedSearch: this.props.search_params.advancedSearch,
      stages: this.props.search_params.stages,
      keyword: keywords,
    });
  }

  onStageTopicsChanged(topics) {
    // let stageTopics = this.state.stageTopics;

    // stageTopics[stage] = topics;

    // this.setState({
    //   stageTopics
    // })

    // let searchTopics = [];

    // stageTopics.map((stage) => {
    //   if (stage !== undefined) {
    //     searchTopics = [ ...searchTopics, ...stage];
    //   }
    // });

    // console.log('searchTopics', searchTopics);

    this.onSearchParamsChanged(topics, 'stages', 'topics');
  }

  nestedValue(selectedValue, value, isRemove = false) {
    const nestedOptionValue = [...selectedValue];

    if (_.isArray(value)) {
      value.forEach((currentValue) => {
        const optionIndex = _.findIndex(
          nestedOptionValue,
          (currentOptionValue) => {
            return String(currentOptionValue) === String(currentValue);
          },
        );
        if (optionIndex === -1 && isRemove === false) {
          nestedOptionValue.push(currentValue);
        } else if (optionIndex > -1 && isRemove === true) {
          nestedOptionValue.splice(optionIndex, 1);
        }
      });
    } else {
      const optionIndex = _.findIndex(selectedValue, (currentValue) => {
        return String(currentValue) === String(value);
      });
      if (optionIndex === -1) {
        nestedOptionValue.push(value);
      } else {
        nestedOptionValue.splice(optionIndex, 1);
      }
    }
    return nestedOptionValue;
  }

  countryList = () => {
    const { country } = this.props.data.initial_search;

    let countryList = [];

    country.forEach((currentCountry) => {
      let newCountryDetails = produce(currentCountry, (draft) => {
        draft.options = [];
        const newGroupLabel = currentCountry.label + '|' + currentCountry.value;
        draft.label = newGroupLabel;
        currentCountry.years.forEach((process) => {
          draft.options.push({
            group: newGroupLabel,
            label: process.year,
            value: process.process_id,
          });
        });
      });

      countryList.push(newCountryDetails);
    });

    return countryList;
  };

  render() {
    const { advanced_search, stages } = this.props.data;
    const country = this.countryList();

    return (
      <div className="search-form-wrapper">
        {this.props.layout !== 'home' && (
          <div>
            <div className="separator" />

            <div className="hlp-pt-30 hlp-mb-40">
              <div className="heading">Text search</div>
              <TextInput
                type="text"
                labelPositionTop
                label="Search for keywords"
                value={this.state.sideBarKeywords}
                onChangeHandler={(event) => this.sideBarKeywordsChanged(event)}
              />
              <Button
                classes="primary fw"
                onClick={() => this.onSubmitSideBarKeywords()}>
                Search
              </Button>
            </div>

            <div className="filter-tabs">
              <div
                className={`filter-tab ${this.state.sidebarFiltersActive ? 'active' : ''
                  }`}
                onClick={() => this.onSidebarFiltersToggle(1)}>
                Filters
              </div>
              <div
                className={`filter-tab ${this.state.sidebarTopicsActive ? 'active' : ''
                  }`}
                onClick={() => this.onSidebarFiltersToggle(2)}>
                Topics
              </div>
            </div>

            <div className="separator" />
            <div className="hlp-pd-15" />

            {this.state.sidebarFiltersActive && (
              <div>
                {this.props.layout === 'searchResult' && this.props.layout !== 'home' && this.props.layout !== 'searchResult-search' && (

                  <div className='orange-text-div'>
                    <div><img alt="" src={require('./../../images/icon-search-orange.svg')} /></div>
                    <div className='orange-text'>
                      Changing the filters below <br />
                      will alter your search results
                    </div>
                  </div>


                )}
                <InitialWrapper layout={this.props.layout}>
                  <SelectGroup
                    direction="column"
                    label="Country & Process"
                    labelWidth="100%"
                    information="Search for a specific country or process. Processes are identified by the year in which they concluded. Note that one country may have multiple processes."
                    isMulti
                    hideSelectedOptions={false}
                    options={country}
                    value={_findArrayOption(
                      country,
                      this.props.search_params.initialSearch.country,
                    )}
                    nestedOptionValue={_findArrayNestedOption(
                      country,
                      this.props.search_params.initialSearch.process,
                    )}
                    onChange={(value) =>
                      this.onSearchParamsChanged(
                        value,
                        'initialSearch',
                        'country',
                      )
                    }
                    onNestedOptionChange={(value, isRemove) =>
                      this.onSearchParamsChanged(
                        this.nestedValue(
                          this.props.search_params.initialSearch.process,
                          value,
                          isRemove,
                        ),
                        'initialSearch',
                        'process',
                      )
                    }
                    filterOption={_filterCountry}
                  />

                  <YearRange
                    label="Year range"
                    information="Search for processes within a given range of years. 'Year' refers to the year in which the process concluded."
                    labelPositionTop={this.props.layout !== 'home'}
                    value={[
                      this.props.search_params.initialSearch.date[0],
                      this.props.search_params.initialSearch.date[1],
                    ]}
                    onChangeHandler={(value, field, subfield) =>
                      this.onSearchParamsChanged(value, 'date', '')
                    }
                  />
                </InitialWrapper>

                <AdvanceWrapper
                  layout={this.props.layout}
                  onAdvancedSearchToggle={() => this.onAdvancedSearchToggle()}
                  onTopicSearchToggle={() => this.onTopicSearchToggle()}
                  advanceToggle={`${this.state.advancedSearchActive && 'active'
                    }`}>
                  <Collapse
                    isOpened={
                      this.state.advancedSearchActive ||
                      this.props.layout !== 'home'
                    }>
                    <div className="hlp-pt-10 hlp-pb-30 AAA">
                      {advanced_search.map((filter, index) => {
                        const filterKey = Object.keys(filter)[0];
                        return (
                          <SelectGroup
                            ref={(ref) => (this.filterRef[index] = ref)}
                            onClick={() => {
                              if (this.filterRef[index]) {
                                setTimeout(
                                  () =>
                                    this.filterRef[index].scrollIntoView({
                                      behavior: 'smooth',
                                      block: 'start',
                                    }),
                                  200,
                                );
                              }
                            }}
                            key={index}
                            direction="column"
                            label={FiltersLabel[filterKey]}
                            labelWidth="100%"
                            information={FiltersTooltip[filterKey]}
                            isMulti
                            closeMenuOnSelect={false}
                            options={filter[filterKey]}
                            value={_findArrayOption(
                              filter[filterKey],
                              this.props.search_params.advancedSearch[
                              filterKey
                              ],
                            )}
                            onChange={(value) =>
                              this.onSearchParamsChanged(
                                value,
                                'advancedSearch',
                                filterKey,
                              )
                            }
                          />
                        );
                      })}
                    </div>
                  </Collapse>
                </AdvanceWrapper>
              </div>
            )}

            {this.state.sidebarTopicsActive && (
              <div className="topic-search-block">
                {stages.map((stage, key) => {
                  return (
                    <PropertiesSelect
                      key={key}
                      seq={key}
                      options={stage}
                      selectedValues={this.props.search_params.stages.topics}
                      onChangeHandler={(stage, topcis) =>
                        this.onStageTopicsChanged(stage, topcis)
                      }
                    />
                  );
                })}
              </div>
            )}
          </div>
        )}

        {this.props.layout === 'home' && (
          <div>
            {/* {this.props.clearAllFilters()} */}
            <InitialWrapper layout={this.props.layout}>
              <SelectGroup
                labelWidth="180px"
                label="Country & Process"
                information="Search for a specific country or process. Processes are identified by the year in which they concluded. Note that one country may have multiple processes."
                isMulti
                // hideSelectedOptions={false}
                options={country}
                value={_findArrayOption(
                  country,
                  this.props.search_params.initialSearch.country,
                )}
                nestedOptionValue={_findArrayNestedOption(
                  country,
                  this.props.search_params.initialSearch.process,
                )}
                onChange={(value) =>
                  this.onSearchParamsChanged(value, 'initialSearch', 'country')
                }
                onNestedOptionChange={(value, isRemove) =>
                  this.onSearchParamsChanged(
                    this.nestedValue(
                      this.props.search_params.initialSearch.process,
                      value,
                      isRemove,
                    ),
                    'initialSearch',
                    'process',
                  )
                }
                filterOption={_filterCountry}
              />
              <YearRange
                label="Year range"
                information="Search for processes within a given range of years. 'Year' refers to the year in which the process concluded."
                labelPositionTop={this.props.layout !== 'home'}
                value={[
                  this.props.search_params.initialSearch.date[0],
                  this.props.search_params.initialSearch.date[1],
                ]}
                onChangeHandler={(value, field, subfield) =>
                  this.onSearchParamsChanged(value, 'date', '')
                }
              />
            </InitialWrapper>

            <AdvanceWrapper
              layout={this.props.layout}
              onAdvancedSearchToggle={() => this.onAdvancedSearchToggle()}
              onTopicSearchToggle={() => this.onTopicSearchToggle()}
              advanceToggle={`${this.state.advancedSearchActive && 'active'}`}
              topicToggle={`${this.state.topicSearchActive && 'active'}`}>
              {(this.state.topicSearchActive ||
                this.props.layout !== 'home') && (
                  <div className="hlp-pt-30 hlp-pb-30 hlp-pl-30 hlp-pr-30 bgc-light">
                    <div className="topic-search-label hlp-mb-15">
                      <strong>
                        Select a specific category in which you want to conduct
                        your search (or select none)
                      </strong>
                    </div>

                    <div className="topic-search-block">
                      <div className="topic-search-fields">
                        {stages.map((stage, key) => {
                          return (
                            <PropertiesSelect
                              key={key}
                              seq={key}
                              options={stage}
                              selectedValues={
                                this.props.search_params.stages.topics
                              }
                              onChangeHandler={(stage, topcis) =>
                                this.onStageTopicsChanged(stage, topcis)
                              }
                            />
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}

              {(this.state.advancedSearchActive ||
                this.props.layout !== 'home') && (
                  <div>
                    {advanced_search.map((filter, index) => {
                      const filterKey = Object.keys(filter)[0];
                      return (
                        <SelectGroup
                          key={index}
                          label={FiltersLabel[filterKey]}
                          information={FiltersTooltip[filterKey]}
                          isMulti
                          closeMenuOnSelect={false}
                          options={filter[filterKey]}
                          value={_findArrayOption(
                            filter[filterKey],
                            this.props.search_params.advancedSearch[filterKey],
                          )}
                          onChange={(value) =>
                            this.onSearchParamsChanged(
                              value,
                              'advancedSearch',
                              filterKey,
                            )
                          }
                        />
                      );
                    })}
                  </div>
                )}
            </AdvanceWrapper>

            <div className="form-block hlp-mb-50">
              <TextInput
                labelClassName="home"
                type="text"
                label="Search for keywords"
                information="Search for keywords within the entire database. Use quotation marks around two or more words to search for phrases. Use plus sign (+) to search for a combinations of words or phrases."
                value={this.props.search_params.keyword}
                onChangeHandler={(event) =>
                  this.onSearchParamsChanged(event.target.value, 'keyword', '')
                }
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.home.data,
    search_params: state.home.search_params,
    searchSuccess: state.search.searchSuccess,
  };
};

// export default connect(mapStateToProps, {
//   searchParamsChanged,
//   submitSearchParams,
// })(SearchForm);


export default withRouter(
  connect(mapStateToProps, { searchParamsChanged, submitSearchParams, clearAllFilters })(SearchForm)
);
